import React from 'react';

import Head from 'next/head';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import NeedIdSelect from '@/components/VikingFlow/NeedIdSelect';

import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

export async function getStaticPaths() {
  const paths = CATEGORY_SUBSETS.map((category) => {
    return {
      params: {
        category: category.url_slug
      }
    };
  });
  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      category: CATEGORY_SUBSETS.filter((category) => category.url_slug === params.category)[0]
    }
  };
}

const Category = ({ category = {} }) => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>
    </Head>
    <Header />
    <NeedIdSelect category={category} />
    <Footer />
  </div>
);

export default Category;
